import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, EnvelopeSimple, ShieldCheck } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const policySections = [
  {
    title: "1. Titolare del trattamento",
    body: [
      "Il titolare del trattamento dei dati personali effettuato tramite l’app e-Tanika è Zerocinquezero srls, contattabile per qualsiasi richiesta in materia di privacy all’indirizzo email info@zerocinquezero.it.",
    ],
  },
  {
    title: "2. Ambito di applicazione",
    body: [
      "La presente informativa descrive le modalità di trattamento dei dati personali effettuate tramite l’app e-Tanika, resa disponibile esclusivamente nel marketplace italiano di Apple App Store.",
      "L’app non richiede la creazione di un account e non prevede la registrazione di profili utente presso il titolare.",
    ],
  },
  {
    title: "3. Categorie di dati trattati",
    body: ["L’app può trattare le seguenti categorie di dati:"],
    list: [
      "dati di localizzazione del dispositivo, previa autorizzazione dell’utente;",
      "immagini acquisite tramite fotocamera, limitatamente alla funzione di scansione del display della pompa carburante o dello scontrino;",
      "dati inseriti o generati localmente dall’utente, quali veicoli, garage, rifornimenti, ricariche, preferenze e informazioni di utilizzo strettamente necessarie al funzionamento dell’app.",
    ],
  },
  {
    title: "4. Dati conservati localmente sul dispositivo",
    body: [
      "e-Tanika è progettata in modo da conservare i dati dell’utente esclusivamente in locale sul dispositivo, tramite database locale gestito dal dispositivo.",
      "I dati relativi al garage, ai veicoli, ai rifornimenti, alle ricariche e alle altre informazioni gestionali non vengono trasmessi ai sistemi del titolare, salvo quanto espressamente indicato nella sezione dedicata alla funzione di scansione immagini.",
      "L’utente può effettuare operazioni di esportazione e importazione dei dati esclusivamente in locale.",
    ],
  },
  {
    title: "5. Finalità del trattamento",
    body: ["I dati sono trattati per le seguenti finalità:"],
    list: [
      "visualizzare le stazioni di servizio carburante e le colonnine di ricarica elettrica;",
      "mostrare i prezzi aggiornati dei carburanti e le informazioni sulle colonnine, inclusa la potenza e la tipologia AC/DC;",
      "gestire il garage dell’utente e i relativi mezzi, compresi i veicoli a doppia alimentazione o con alimentazione elettrica;",
      "consentire la registrazione dei rifornimenti e delle ricariche, anche direttamente dalla mappa;",
      "consentire la navigazione verso una posizione selezionata e la condivisione della posizione;",
      "consentire la scansione del display della pompa o dello scontrino per agevolare la compilazione dei dati del rifornimento o della ricarica.",
    ],
  },
  {
    title: "6. Base giuridica del trattamento",
    body: [
      "Il trattamento dei dati avviene, a seconda dei casi, sulla base dell’esecuzione di un servizio richiesto dall’utente e, per le funzionalità che richiedono autorizzazioni del dispositivo o la trasmissione di immagini a un fornitore terzo, sulla base del consenso dell’utente.",
      "Il conferimento dei dati necessari all’utilizzo di localizzazione, fotocamera e scansione è facoltativo; il mancato conferimento può però impedire l’utilizzo delle relative funzionalità.",
    ],
  },
  {
    title: "7. Accesso alla posizione",
    body: [
      "L’app richiede l’accesso alla posizione del dispositivo esclusivamente per localizzare l’utente rispetto ai distributori e alle colonnine, mostrare i punti di interesse vicini, avviare la navigazione verso un luogo selezionato e consentire la condivisione della posizione.",
      "In assenza di autorizzazione alla localizzazione, le funzionalità basate sulla posizione potrebbero risultare non disponibili o limitate.",
    ],
  },
  {
    title: "8. Accesso alla fotocamera",
    body: [
      "L’app richiede l’accesso alla fotocamera esclusivamente per consentire all’utente di acquisire l’immagine del display della pompa carburante o dello scontrino e utilizzare la funzione di scansione.",
      "In assenza di autorizzazione alla fotocamera, la funzione di scansione non sarà disponibile.",
    ],
  },
  {
    title: "9. Trasmissione delle immagini a OpenAI",
    body: [
      "Quando l’utente utilizza la funzione di scansione, l’immagine acquisita viene trasmessa direttamente dall’app alle API di OpenAI per consentire il riconoscimento del contenuto e l’estrazione delle informazioni utili alla compilazione del rifornimento o della ricarica.",
      "La funzione utilizza un modello di riconoscimento immagini configurato dal titolare come “OpenAI 5.4 mini”.",
      "La trasmissione avviene esclusivamente su iniziativa dell’utente, nel momento in cui viene utilizzata la funzione di scansione.",
      "L’utente è invitato a non inquadrare immagini contenenti dati non necessari o informazioni eccedenti rispetto alla finalità del riconoscimento.",
    ],
  },
  {
    title: "10. Conservazione dei dati",
    body: [
      "I dati memorizzati dall’app per la gestione del garage, dei veicoli, dei rifornimenti e delle ricariche restano sul dispositivo fino alla loro cancellazione da parte dell’utente o fino alla disinstallazione dell’app, fatti salvi eventuali backup locali gestiti direttamente dall’utente.",
      "Le immagini trasmesse a OpenAI per la funzione di scansione sono trattate secondo i tempi di conservazione dichiarati dal relativo fornitore. In base alle informazioni fornite dal titolare, il tempo di ritenzione dichiarato è pari a 30 giorni.",
    ],
  },
  {
    title: "11. Comunicazione dei dati a terzi",
    body: [
      "I dati non sono oggetto di diffusione.",
      "Le immagini utilizzate per la scansione possono essere comunicate a OpenAI esclusivamente per la finalità di elaborazione e riconoscimento del contenuto dell’immagine, nei limiti strettamente necessari all’erogazione della funzione richiesta dall’utente.",
      "L’app utilizza inoltre cartografia OpenStreetMap per la visualizzazione geografica. In base alla configurazione dichiarata dal titolare, non sono presenti sistemi di crash reporting, telemetry o SDK pubblicitari.",
    ],
  },
  {
    title: "12. Trasferimenti di dati verso Paesi terzi",
    body: [
      "Qualora il trattamento effettuato tramite le API di OpenAI comporti il trasferimento di dati personali verso Paesi situati al di fuori dello Spazio Economico Europeo, tale trasferimento avverrà nei limiti e secondo i meccanismi previsti dalla normativa applicabile.",
    ],
  },
  {
    title: "13. Diritti dell’interessato",
    body: [
      "L’utente può esercitare, nei limiti previsti dagli articoli 15 e seguenti del Regolamento (UE) 2016/679, i diritti di accesso, rettifica, cancellazione, limitazione del trattamento, opposizione e, ove applicabile, portabilità dei dati.",
      "L’utente può inoltre revocare in qualsiasi momento i consensi eventualmente prestati, fermo restando che la revoca non pregiudica la liceità del trattamento effettuato prima della revoca.",
      "Per l’esercizio dei propri diritti, l’utente può scrivere a info@zerocinquezero.it.",
      "L’utente ha altresì il diritto di proporre reclamo al Garante per la protezione dei dati personali.",
    ],
  },
  {
    title: "14. Minori",
    body: [
      "L’app non è destinata intenzionalmente a raccogliere dati personali di minori in assenza dei presupposti di legge applicabili.",
    ],
  },
  {
    title: "15. Modifiche alla presente informativa",
    body: ["Il titolare si riserva il diritto di aggiornare la presente Privacy Policy."],
  },
];

export default function PrivacyPolicyPage() {
  const [pointerStyle, setPointerStyle] = useState({ "--mouse-x": "50%", "--mouse-y": "18%" });

  const handlePointerMove = (event) => {
    const x = `${Math.round((event.clientX / window.innerWidth) * 100)}%`;
    const y = `${Math.round((event.clientY / window.innerHeight) * 100)}%`;
    setPointerStyle({ "--mouse-x": x, "--mouse-y": y });
  };

  return (
    <div className="app-shell min-h-screen overflow-x-hidden bg-[#050505] text-[#F5F5F7]" style={pointerStyle} onPointerMove={handlePointerMove} data-testid="privacy-policy-page">
      <div className="reactive-background" data-testid="privacy-reactive-background-layer" aria-hidden="true">
        <span className="reactive-glow reactive-glow-primary" />
        <span className="reactive-glow reactive-glow-accent" />
        <span className="reactive-scanline" />
      </div>

      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#050505]/70 backdrop-blur-xl" data-testid="privacy-header">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8 lg:px-12">
          <Link to="/" className="group flex items-center gap-3" data-testid="privacy-logo-home-link" aria-label="Torna alla home ZeroCinqueZero">
            <span className="grid h-10 w-10 place-items-center border border-white/15 bg-white text-sm font-black text-black transition-transform duration-300 group-hover:-translate-y-0.5" data-testid="privacy-logo-mark">
              050
            </span>
            <span className="hidden text-sm font-semibold uppercase tracking-[0.24em] text-white sm:inline" data-testid="privacy-brand-name">
              ZeroCinqueZero
            </span>
          </Link>
          <Button asChild variant="outline" className="h-11 rounded-none border-white/15 bg-transparent px-5 text-white transition-[border-color,transform,background-color] duration-300 hover:-translate-y-0.5 hover:border-white/35 hover:bg-white/10" data-testid="privacy-back-home-button">
            <Link to="/"><ArrowLeft size={17} /> Home</Link>
          </Button>
        </div>
      </header>

      <main className="px-5 pb-16 pt-32 sm:px-8 sm:pb-24 sm:pt-40 lg:px-12" data-testid="privacy-main-content">
        <div className="mx-auto max-w-5xl">
          <section className="mb-12 border border-white/10 bg-[#0F0F13]/80 p-6 shadow-2xl backdrop-blur-xl sm:p-10" data-testid="privacy-hero-card">
            <p className="mb-5 inline-flex items-center gap-3 border border-white/10 bg-white/[0.03] px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-[#8B8B96]" data-testid="privacy-eyebrow">
              <ShieldCheck size={18} weight="fill" className="text-[#0047FF]" /> Informativa privacy app
            </p>
            <h1 className="text-5xl font-black leading-[0.92] tracking-[-0.065em] text-white sm:text-6xl lg:text-7xl" data-testid="privacy-title">
              Privacy Policy e-Tanika
            </h1>
            <p className="mt-7 max-w-3xl text-base leading-8 text-[#B8B8C2]" data-testid="privacy-intro">
              Informativa sul trattamento dei dati personali effettuato tramite l’app e-Tanika.
            </p>
            <a href="mailto:info@zerocinquezero.it" className="mt-8 inline-flex items-center gap-3 text-sm font-semibold text-white transition-colors duration-300 hover:text-[#7EA0FF]" data-testid="privacy-email-link">
              <EnvelopeSimple size={22} weight="fill" className="text-[#FF2E00]" /> info@zerocinquezero.it
            </a>
          </section>

          <div className="space-y-5" data-testid="privacy-sections-list">
            {policySections.map((section, index) => (
              <article key={section.title} className="border border-white/10 bg-[#0F0F13]/75 p-6 backdrop-blur-xl sm:p-8" data-testid={`privacy-section-${index + 1}`}>
                <h2 className="text-2xl font-bold tracking-[-0.04em] text-white" data-testid={`privacy-section-title-${index + 1}`}>
                  {section.title}
                </h2>
                <div className="mt-5 space-y-4 text-base leading-8 text-[#B8B8C2]" data-testid={`privacy-section-body-${index + 1}`}>
                  {section.body.map((paragraph) => (
                    <p key={paragraph} data-testid={`privacy-section-paragraph-${index + 1}`}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="space-y-3 pl-5" data-testid={`privacy-section-list-${index + 1}`}>
                      {section.list.map((item) => (
                        <li key={item} className="list-disc marker:text-[#0047FF]" data-testid={`privacy-section-list-item-${index + 1}`}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10 px-5 py-8 text-sm text-[#8B8B96] sm:px-8 lg:px-12" data-testid="privacy-footer">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="privacy-footer-brand">© ZeroCinqueZero — Software house italiana · P.IVA 04830250231</p>
          <div className="flex flex-wrap gap-5" data-testid="privacy-footer-links">
            <Link to="/privacy-policy" className="transition-colors duration-300 hover:text-white" data-testid="privacy-footer-site-privacy-link">Privacy</Link>
            <Link to="/cookie-policy" className="transition-colors duration-300 hover:text-white" data-testid="privacy-footer-cookie-policy-link">Cookie Policy</Link>
            <Link to="/" className="transition-colors duration-300 hover:text-white" data-testid="privacy-footer-home-link">Torna alla home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}